<div class="empty-panel d-flex flex-justify-center flex-align-center w-base-text-slight-large-bold">
    <div>
        {{message}}
    </div>
</div>
